module.exports = __webpack_public_path__ + "static/media/P.fa15e76f.jpg";